import {createUseStyles} from 'react-jss';
import PropTypes from 'prop-types';
import LoyaltyPointsIcon from '../../../../../imgs/LoyaltyPointsIcon';
import Translation from '../../../../lang/Translation';

const useStyles = createUseStyles({
  loyaltyPointsIcon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 5,
  },
  loyaltyPointsText: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    paddingBottom: props => (props.isHeader ? '10px' : 0),
    display: 'flex',
    width: '100%',
  },
});

const LoyaltyPointsLine = (props) => {
  const classes = useStyles(props);
  return (
    <div className={classes.container}>
      <div className={classes.loyaltyPointsIcon}>
        <LoyaltyPointsIcon iconColor={props.iconColor} />
      </div>
      <div data-test="loyaltyPointsLine" className={classes.loyaltyPointsText}>
        <Translation placeholderValues={[props.loyaltyPoints]}>{`orderSummary.loyaltyPoints.${props.isGuest ? 'guestUser' : 'registeredUser'}`}</Translation>
      </div>
    </div>
  );
};

LoyaltyPointsLine.propTypes = {
  loyaltyPoints: PropTypes.number,
  iconColor: PropTypes.string,
  isGuest: PropTypes.bool,
  isHeader: PropTypes.bool,
};

export default LoyaltyPointsLine;
